import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { EditorSignUpField } from '@dev/template-editor';
import { getMergeFieldsStore } from '@/store/mergeFields/actions';
import { mapMergeFieldToEditorSignUpField } from '@/services/tools/mapMergeFieldToEditorSignUpField';

interface FormMergeFields {
    fields: EditorSignUpField[];
    isLoading?: boolean;
}

export const useTemplateEditorFormMergeFields = (): FormMergeFields => {
    const { data, maxFieldsValuesMap } = useSelector(getMergeFieldsStore);
    const fields = useMemo(() => data?.MergeFields?.filter(({ CollectName }) => CollectName), [data])?.map(
        (field): EditorSignUpField => mapMergeFieldToEditorSignUpField(field, maxFieldsValuesMap),
        [data]
    );
    return { fields };
};
